<template>
  <!-- Quotation定制化服务-报价(列表) -->
  <div class="packageWrap" v-if="quotationList?.length > 0">
    <div class="shadeWrap" v-for="(parent, index) in quotationList" :key="`parent${index}`">
      <!-- Billing to -->
      <el-row :gutter="10" class="pt10 pb10 fxRow borderTop">
        <el-col :span="4">
          <p class="pl4 fs14 fwb billingTo">
            Client Code:
            <span class="fw400 fs12">{{ parent.clientCode }}</span>
          </p>
        </el-col>
        <el-col :span="7">
          <p class="pl4 fs14 fwb billingTo">
            Billing to:
            <span class="fw400 fs12">{{ parent.companyTitle }}</span>
          </p>
        </el-col>
        <el-col :span="6">
          <p class="fs14 fwb billingTo">
            Address:
            <span class="fw400 fs12">{{ parent.companyAddress }}</span>
          </p>
        </el-col>
        <el-col :span="4">
          <p class="fs14 fwb billingTo">
            Country:
            <span class="fw400 fs12">{{ parent.companyCountry }}</span>
          </p>
        </el-col>
        <el-col :span="3">
          <p class="fs14 fwb billingTo">
            Code:
            <span class="fw400 fs12">{{ parent.companyPostalCode }}</span>
          </p>
        </el-col>
      </el-row>

      <!-- 供应商 -->
      <el-row :gutter="10" class="pt10 pb10 fxRow borderTop">
        <el-col :span="8">
          <p class="pl4 fs14 fwb billingTo">
            Supplier:
            <span class="fw400 fs12">{{ parent.supplier?.companyName || "" }}</span>
          </p>
        </el-col>
        <el-col :span="8">
          <p class="fs14 fwb billingTo">
            Invoice Template:
            <span class="fw400 fs12">{{ parent.invoiceTemplate?.templateName || "" }}</span>
          </p>
        </el-col>
        <el-col :span="8">
          <p class="fs14 fwb billingTo">
            Bank Accounts:
            <span class="fw400 fs12">{{ getBankAccountTags(parent) }}</span>
          </p>
        </el-col>
      </el-row>

      <!-- 表格标题 -->
      <div class="billingTitle">
        <el-row :gutter="10" class="pt10 pb10 fxRow borderTop">
          <el-col :span="5">
            <p class="fs12 fwb tac">Fee Schedule</p>
            <!-- <p class="fs12 fwb tac">收费安排</p> -->
          </el-col>
          <el-col :span="3">
            <p class="fs12 fwb tac">Covered Period</p>
            <!-- <p class="fs12 fwb tac">涵盖的服务期间</p> -->
          </el-col>
          <el-col :span="3">
            <p class="fs12 fwb tac">Amount</p>
            <!-- <p class="fs12 fwb tac">金额</p> -->
          </el-col>
          <el-col :span="3">
            <p class="fs12 fwb tac">Incl. Third Party Fee</p>
            <!-- <p class="fs12 fwb tac">第三方金额</p> -->
          </el-col>
          <el-col :span="3">
            <p class="fs12 fwb tac">Incl. Other Fee</p>
          </el-col>
          <el-col :span="3">
            <p class="fs12 fwb tac">Payment Due Date</p>
            <!-- <p class="fs12 fwb tac">支付到期日</p> -->
          </el-col>
          <el-col :span="2">
            <p class="fs12 fwb tac">Generic Invoice</p>
            <!-- <p class="fs12 fwb tac">普通发票</p> -->
          </el-col>
          <el-col :span="2">
            <p class="fs12 fwb tac">Status</p>
            <!-- <p class="fs12 fwb tac">状态</p> -->
          </el-col>
        </el-row>
      </div>

      <!-- 表格内容 -->
      <div class="billingPart" v-for="(sub, idx) in parent.partList" :key="`sub${idx}`">
        <div class="billingContent" v-for="(grand, ids) in sub.itemList" :key="`grand${ids}`">
          <el-row :gutter="10" class="pt10 pb10 fxRow borderTop">
            <el-col :span="5">
              <p class="fs12 tac lh16">{{ grand.title }}</p>
            </el-col>
            <el-col :span="3">
              <p class="fs12 tac lh16">{{ grand.startDate }} ~ {{ grand.endDate }}</p>
            </el-col>
            <el-col :span="3">
              <p class="fs12 tac lh16 orange newline">{{ currencySymbolFormat(parent?.bankAccountList?.[0]?.billingCurrency) }}{{ grand.amount }}</p>
            </el-col>
            <el-col :span="3">
              <p class="fs12 tac lh16 orange newline">
                {{ currencySymbolFormat(parent?.bankAccountList?.[0]?.billingCurrency) }}{{ grand.thirdPartyFee }}
                <el-popover placement="bottom" trigger="hover" v-if="grand.noteForThirdParty">
                  <p class="fs12 m0">{{ grand.noteForThirdParty }}</p>
                  <span slot="reference" class="fs13 blackD8 el-icon-question"></span>
                </el-popover>
              </p>
            </el-col>
            <el-col :span="3">
              <p class="fs12 tac lh16 orange newline">
                {{ currencySymbolFormat(parent?.bankAccountList?.[0]?.billingCurrency) }}{{ grand.otherFee }}
                <el-popover placement="bottom" trigger="hover" v-if="grand.noteForOther">
                  <p class="fs12 m0">{{ grand.noteForOther }}</p>
                  <span slot="reference" class="fs13 blackD8 el-icon-question"></span>
                </el-popover>
              </p>
            </el-col>
            <el-col :span="3"></el-col>
            <el-col :span="2"></el-col>
            <el-col :span="2"></el-col>
          </el-row>
        </div>

        <!-- 小结 -->
        <div class="billingBrief">
          <el-row :gutter="10" class="pt10 pb10 fxRow borderTop borderBottom">
            <el-col :span="5">
              <p class="fs12 tac lh16">{{ sub.subTotalDesp }}</p>
            </el-col>
            <el-col :span="3"></el-col>
            <el-col :span="3">
              <p class="fs12 tac lh16 pb2">Subtotal</p>
              <p class="fs12 tac lh16 fwb orange newline">
                {{ currencySymbolFormat(parent?.bankAccountList?.[0]?.billingCurrency) }}{{ sub.subTotalPrice }}
              </p>
            </el-col>
            <el-col :span="3">
              <p class="fs12 tac lh16 pb2">Subtotal</p>
              <p class="fs12 tac lh16 fwb orange newline">
                {{ currencySymbolFormat(parent?.bankAccountList?.[0]?.billingCurrency) }}{{ sub.subTotalThirdPartyFee }}
              </p>
            </el-col>
            <el-col :span="3">
              <p class="fs12 tac lh16 pb2">Subtotal</p>
              <p class="fs12 tac lh16 fwb orange newline">
                {{ currencySymbolFormat(parent?.bankAccountList?.[0]?.billingCurrency) }}{{ sub.subTotalOtherFee }}
              </p>
            </el-col>
            <el-col :span="3">
              <p class="fs12 tac lh16" v-if="sub.isDownPayment">Payable upon submission</p>
              <p class="fs12 tac lh16" v-else>{{ sub.paymentDueTime }}</p>
            </el-col>
            <el-col :span="2">
              <template v-if="getInvoiceNumber(sub.id, 1)">
                <p class="fs12 tac lh16 crp blue" @click="invoiceLink(getInvoiceNumber(sub.id, 1))">Invoice</p>
              </template>
              <template v-if="getInvoiceNumber(sub.id, 2)">
                <p class="fs12 tac lh16 crp blue pt4" @click="invoiceLink(getInvoiceNumber(sub.id, 2))">Credit Invoice</p>
              </template>
            </el-col>
            <el-col :span="2">
              <p class="fs12 tac lh16">{{ getOrderStatus(sub.id) }}</p>
            </el-col>
          </el-row>
          <!-- 空行占位 -->
          <div class="wdb100 hg40"></div>
        </div>
      </div>

      <!-- 总结 -->
      <div class="billingBottom">
        <el-row :gutter="10" class="pt10 pb10 fxRow borderTop borderBottom">
          <el-col :span="5">
            <p class="fs12 text-center lh16">{{ parent.sumTotalDesp }}</p>
          </el-col>
          <el-col :span="3"></el-col>
          <el-col :span="3">
            <p class="fs12 text-center lh16 pb2">Total</p>
            <p class="fs12 text-center lh16 fwb orange newline">
              {{ currencySymbolFormat(parent?.bankAccountList?.[0]?.billingCurrency) }}{{ parent.sumTotalPrice }}
            </p>
          </el-col>
          <el-col :span="3">
            <p class="fs12 text-center lh16 pb2">Total</p>
            <p class="fs12 text-center lh16 fwb orange newline">
              {{ currencySymbolFormat(parent?.bankAccountList?.[0]?.billingCurrency) }}{{ parent.sumTotalThirdPartyFee }}
            </p>
          </el-col>
          <el-col :span="3">
            <p class="fs12 text-center lh16 pb2">Total</p>
            <p class="fs12 text-center lh16 fwb orange newline">
              {{ currencySymbolFormat(parent?.bankAccountList?.[0]?.billingCurrency) }}{{ parent.sumTotalOtherFee }}
            </p>
          </el-col>
          <el-col :span="3"></el-col>
          <el-col :span="2"></el-col>
          <el-col :span="2"></el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [formatterMixin],
  props: {
    quotationList: {
      type: Array,
      default: () => [],
    },
    orderInfoList: {
      type: Array,
      default: () => [],
    },
    orderRefundList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    // 获取银行账户tag
    getBankAccountTags(data) {
      const { bankAccountList } = data;
      if (bankAccountList?.length > 0) {
        const tagList = bankAccountList.map(item => item.tag);
        return tagList.join(", ");
      } else {
        return "";
      }
    },
    // 通过id匹配对应的订单状态
    getOrderStatus(id) {
      const orderStatus = this.orderInfoList?.find(item => item.partId == id)?.status || "";
      // orderStatusFormat是formatterMixin中的方法
      return this.orderStatusFormat(orderStatus);
    },
    // 通过id匹配对应的发票号码
    getInvoiceNumber(id, invoiceType) {
      if (invoiceType == 1) {
        // 普通发票(Invoice)
        const currentOrderData = this.orderInfoList?.find(item => item.partId == id) || {};
        const invoiceNumber = currentOrderData?.customerInvoice?.invoiceNumber || "";
        return invoiceNumber;
      } else {
        // 退款发票(Credit Invoice)
        const currentOrderData = this.orderRefundList?.find(item => item.partId == id) || {};
        const invoiceNumber = currentOrderData?.customerInvoice?.invoiceNumber || "";
        return invoiceNumber;
      }
    },
    // 发票跳转
    invoiceLink(invoiceNumber) {
      const newPage = `${process.env.VUE_APP_URL_INVOICE}/invoice?invoiceNo=${invoiceNumber}`;
      window.open(newPage, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.packageWrap {
  width: 100%;

  .shadeWrap {
    width: 100%;
    padding: 0 5px;
    background-color: #fdf6ec;
    border-left: 1px solid #e4e7ed;
    border-right: 1px solid #e4e7ed;
    margin-bottom: 20px;
  }

  .shadeWrap:last-child {
    margin-bottom: 0;
  }

  .borderTop {
    border-top: 1px solid #e4e7ed;
  }

  .borderBottom {
    border-bottom: 1px solid #e4e7ed;
  }

  p {
    margin: 0;
    line-height: 20px;
    color: #011a45;
  }
}
</style>
